/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createOption = createAsyncThunk(
  'products/createOption',
  async ({ productId, name, values }, {
    extra: { Logger, Toast, sdk },
  }) => {
    try {
      const { data } = await sdk.products.createOption(productId, name, values);
      return data;
    } catch (error) {
      Logger.log('UI', 'ToastCannotAddOption');
      Toast(
        'Option is not created. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error option adding'), { error }, [
        'CreateOptionFailed',
        'Option is not created on the backend.',
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    createOption.pending,
    (state, { meta }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = true;
        }
      });
    },
  ).addCase(
    createOption.fulfilled,
    (state, { payload }) => {
      state.items = state.items.map((product) => {
        if (product._id === payload._id) return { ...product, isBusy: false, ...payload };
        return product;
      });
    },
  ).addCase(
    createOption.rejected,
    (state, { meta, error }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = false;
        }
      });
      state.error = error;
    },
  );
};
